import messages from './messages';

export const MAX_CONVERSATIONAL_AI_QUESTIONS = 1;
export const MAX_GOAL_ANSWERS_CONVERSATIONAL = 6;

export const ERROR_CODES_CONVERSATIONAL = {
  objectiveTooLong: 'objectiveTooLong',
  objectiveEmpty: 'objectiveEmpty',
  noGoals: 'noGoals',
  goalEmpty: 'goalEmpty',
  goalTooLong: 'goalTooLong',
  tooManyGoals: 'tooManyGoals',
};

export const ERROR_CODES_CONVERSATIONAL_MESSAGES = {
  [ERROR_CODES_CONVERSATIONAL.objectiveTooLong]:
    messages.errors[ERROR_CODES_CONVERSATIONAL.objectiveTooLong],
  [ERROR_CODES_CONVERSATIONAL.objectiveEmpty]:
    messages.errors[ERROR_CODES_CONVERSATIONAL.objectiveEmpty],
  [ERROR_CODES_CONVERSATIONAL.goalTooLong]:
    messages.errors[ERROR_CODES_CONVERSATIONAL.goalTooLong],
  [ERROR_CODES_CONVERSATIONAL.goalEmpty]:
    messages.errors[ERROR_CODES_CONVERSATIONAL.goalEmpty],
  [ERROR_CODES_CONVERSATIONAL.noGoals]:
    messages.errors[ERROR_CODES_CONVERSATIONAL.noGoals],
  [ERROR_CODES_CONVERSATIONAL.tooManyGoals]:
    messages.errors[ERROR_CODES_CONVERSATIONAL.tooManyGoals],
};
